/**
 * Common status filter tabs for admin list pages.
 *
 * Props:
 * - value: "active" | "inactive" | "deleted" | "all"
 * - onChange: (next) => void
 * - counts: optional { active, inactive, deleted, all }
 * - testId: prefix for data-testid
 */
export function StatusFilterTabs({ value = "active", onChange, counts, testId = "status-filter" }) {
  const opts = [
    { k: "active", label: "Active" },
    { k: "inactive", label: "Inactive" },
    { k: "deleted", label: "Deleted" },
    { k: "all", label: "All" },
  ];
  return (
    <div className="inline-flex rounded-lg border border-slate-200 bg-white p-1" data-testid={testId}>
      {opts.map((o) => {
        const active = value === o.k;
        const count = counts ? counts[o.k] : undefined;
        return (
          <button
            key={o.k}
            type="button"
            onClick={() => onChange?.(o.k)}
            data-testid={`${testId}-${o.k}`}
            className={`inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-xs font-semibold transition ${
              active
                ? "bg-[#101876] text-white"
                : "text-slate-600 hover:bg-slate-100"
            }`}
          >
            {o.label}
            {typeof count === "number" && (
              <span className={`rounded-full px-1.5 text-[10px] ${active ? "bg-white/25" : "bg-slate-100 text-slate-600"}`}>
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
